const top_mv = () => {
	const mv_slide = document.querySelector('.p-top__mv__slide');
	if(mv_slide !== null){

		// webp判定
		is_webp(mv_slide);

		// 4-9月、10-3月でMV切り替え
		const today = new Date();
		if(4 <= today.getMonth() && 10 > today.getMonth()){
			mv_slide.classList.add('is-spring');
			document.querySelector('.p-top__mv__catch').classList.add('is-spring');
		} else {
			mv_slide.classList.add('is-autumn');
			document.querySelector('.p-top__mv__catch').classList.add('is-autumn');
		}

		// MVのスライド設定
		const swiper = new Swiper(mv_slide, {
			loop: true,
			autoplay: {
				delay: 2000,
			},
			speed: 800,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
		});
	}
}